import { SPAM_GUARD_MECHANISM, SPAM_GUARD_MECHANISMS_ENUM } from '../Utils/Constants';
import DI from '../Utils/DI';
import IDataManager from './IDataManager';

class SpamGuardManager {
    protected get dataManager(): IDataManager {
        return DI.get('DataManager');
    }

    performSpamSafetyGuard(): Promise<any> {
        return new Promise((resolve, reject) => {
            if (SPAM_GUARD_MECHANISM === SPAM_GUARD_MECHANISMS_ENUM.RECAPTCHA) {
                const recaptchaManager = this.dataManager.convertToRecaptchaManager();
                recaptchaManager.requestToken()
                    .then((token) => {
                        recaptchaManager.validateRecaptcha(token)
                            .then(() => resolve(''))
                            .catch((error) => reject(error));
                    })
                    .catch((error) => reject(error));
            } else {
                resolve('');
            }
        });
    }
}

export default SpamGuardManager;
